import React, { FC } from 'react';
import Badge from '@atlaskit/badge';
import { token } from '@atlaskit/tokens';
import pluralize from 'pluralize';

import {
  spaceTopComfortable,
  spaceGapMinimum,
  flex,
  alignItemsCenter,
  INCIDENT_COLOR,
} from '@/styles';

import { incidentIconStyles } from './styles';

type IncidentsListProps = {
  incidentsCount: number;
};

const IncidentsList: FC<IncidentsListProps> = ({ incidentsCount }) => {
  if (incidentsCount === 0) {
    return <></>;
  }

  return (
    <div css={[spaceTopComfortable, spaceGapMinimum, flex, alignItemsCenter]}>
      <Badge
        style={{
          backgroundColor: INCIDENT_COLOR,
          color: token('color.text.inverse', 'white'),
        }}
      >
        {incidentsCount}
      </Badge>
      <b>Associated {pluralize('Incident', incidentsCount)}</b>
      <span css={incidentIconStyles}>{String.fromCodePoint(0x1f525)}</span>
    </div>
  );
};

export default IncidentsList;
